module.exports = __webpack_public_path__ + "img/search.67bd41b4.svg";